import { createSlice } from '@reduxjs/toolkit';
import { m } from '../../../utils/date';


const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 2,
    }
};

const processBOMSlice = createSlice({
    name: 'processBOM',
    initialState,
    reducers: {
        funGetProcessBOM(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map((processBOM ) =>{
                return{
                    ...processBOM,
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const processBOMActions = processBOMSlice.actions;
export default processBOMSlice.reducer;